import { scriptHideProperty } from '@ps/utils/config'
import CustomWidgetInt from '@ps/views/workbench/right-pane/self-dev-script/CustomWidgetInt'
import CustomWidgetNode from '@ps/views/workbench/right-pane/self-dev-script/CustomWidgetNode'
import CustomWidgetPoint from '@ps/views/workbench/right-pane/self-dev-script/CustomWidgetPoint'
import CustomWidgetTexture from '@ps/views/workbench/right-pane/self-dev-script/CustomWidgetTexture'
import CustomWidgetPrefab from '@ps/views/workbench/right-pane/self-dev-script/CustomWidgetPrefab.vue'
import CustomWidgetMapping from '@ps/views/workbench/right-pane/self-dev-script/CustomWidgetMapping.vue'
import CustomWidgetCustomEvent from '@ps/views/workbench/right-pane/self-dev-script/CustomWidgetCustomEvent'
import { qcColor2elColor, isQcColor } from '@ps/utils/game'
import gameIframe from '@ps/bridge/iframe/iframe'
import _ from 'lodash'

function dealTypeArray(
  i,
  formValue,
  uiSchema,
  script,
  component,
  field,
  buttonText,
  title,
  subTitle,
) {
  const temp = {}
  temp[i] = ''
  const temp1 = {}
  temp1[i] = {
    component,
    title: subTitle || i,
    field,
  }
  const qc = gameIframe.qc
  // el-shema-form对于数组类型的属性需要多加一层key
  formValue[script.uuid][i] = []
  uiSchema[script.uuid].initData[i] = []
  if (typeof script[i] !== 'undefined' && script[i]) {
    script[i].forEach((data) => {
      const obj = {}
      if (data && isQcColor(data)) {
        data = qcColor2elColor(data)
      } else if (data && data instanceof qc.Node) {
        data = data.name
      }
      obj[i] = data
      formValue[script.uuid][i].push(obj)
    })
    uiSchema[script.uuid].initData[i] = _.cloneDeep(formValue[script.uuid][i])
  }

  uiSchema[script.uuid].properties[i] = {
    addable: {
      style: {
        fontSize: '14px',
      },
      text: buttonText,
      type: 'primary',
    },
    items: {
      default: temp,
      properties: temp1,
      type: 'object',
    },
    border: false,
    removable: true,
    title,
    type: 'array',
  }
}

// eslint-disable-next-line no-unused-vars
function dealTypeObject(i, uiSchema, script, component, field, title) {
  const properties = {}

  // el-shema-form对于对象类型的属性需要多加一层key
  if (typeof script[i] !== 'undefined') {
    for (const attr in script[i]) {
      properties[attr] = {
        title: attr,
        component,
        field,
      }
    }
  }

  uiSchema[script.uuid].properties[i] = {
    properties,
    border: false,
    title,
    type: 'object',
  }
}

function calForm(script, Serializer, formValue, uiSchema) {
  const serializableFields = script.serializableFields

  // 循环组件身上的属性
  for (const i in serializableFields) {
    if (i === 'enable' || i === 'runInEditor') {
      // eslint-disable-next-line no-continue
      continue
    }

    if (typeof script.animationId !== 'undefined') {
      formValue[script.uuid]['animationName'] = script.animationId
    }

    // 有些属性不用显示
    if (scriptHideProperty.indexOf(i) > -1) {
      // eslint-disable-next-line no-continue
      continue
    }

    if (serializableFields[i] !== Serializer.AUTO) {
      formValue[script.uuid][i] = script[i] || null
      uiSchema[script.uuid].initData[i] = script[i] || null
    }

    // 对不同类型的值赋予不同类型的组件描述
    switch (serializableFields[i]) {
      case Serializer.INT:
        uiSchema[script.uuid].properties[i] = {
          component: CustomWidgetInt,
          title: i,
        }
        break
      case Serializer.INTS:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          CustomWidgetInt,
          { entity: 'Int' },
          '新增int',
          i + ' - 整型int列表',
        )
        break
      case Serializer.NUMBER:
        uiSchema[script.uuid].properties[i] = {
          component: 'input',
          title: i,
          field: {
            type: 'number',
          },
        }
        break
      case Serializer.NUMBERS:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          'input',
          { type: 'number' },
          '新增Number',
          i + ' - Number列表',
        )
        break
      case Serializer.BOOLEAN:
        uiSchema[script.uuid].properties[i] = {
          component: 'switch',
          title: i,
          field: {
            type: 'boolean',
          },
        }
        break
      case Serializer.BOOLEANS:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          'switch',
          { type: 'boolean' },
          '新增boolean',
          i + ' - boolean列表',
        )
        break
      case Serializer.STRING:
        uiSchema[script.uuid].properties[i] = {
          component: 'input',
          title: i,
          field: {
            type: 'string',
          },
        }
        break
      case Serializer.STRINGS:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          'input',
          { type: 'string' },
          '新增string',
          i + ' - string列表',
        )
        break
      case Serializer.MAPPING:
        uiSchema[script.uuid].properties[i] = {
          component: CustomWidgetMapping,
          title: i,
        }
        break
      case Serializer.COLOR:
        if (script[i]) {
          const _color = qcColor2elColor(script[i])
          formValue[script.uuid][i] = _color
          uiSchema[script.uuid].initData[i] = _color
        }
        uiSchema[script.uuid].properties[i] = {
          component: 'color-picker',
          title: i,
        }
        break
      case Serializer.COLORS:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          'color-picker',
          { type: 'string' },
          '新增color',
          i + ' - color列表',
        )
        break
      case Serializer.POINT:
        uiSchema[script.uuid].properties[i] = {
          component: CustomWidgetPoint,
          title: i,
          field: {
            entity: 'Point',
          },
        }
        break
      case Serializer.POINTS:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          CustomWidgetPoint,
          { entity: 'Point' },
          '新增坐标点',
          i + ' - 坐标点列表',
        )
        break
      case Serializer.RECTANGLE:
        break
      case Serializer.RECTANGLES:
        break
      case Serializer.CIRCLE:
        break
      case Serializer.FONT:
        break
      case Serializer.FONTS:
        break
      case Serializer.CIRCLES:
        break
      case Serializer.ELLIPSE:
        break
      case Serializer.ELLIPSES:
        break
      case Serializer.GEOM:
      case Serializer.GEOMS:
        break
      case Serializer.NODE:
        uiSchema[script.uuid].properties[i] = {
          component: CustomWidgetNode,
          title: i,
          field: {
            entity: 'Node',
          },
        }
        if (script[i]) {
          formValue[script.uuid][i] = script[i].name
          uiSchema[script.uuid].initData[i] = script[i].name
        } else {
          formValue[script.uuid][i] = null
          uiSchema[script.uuid].initData[i] = null
        }
        break
      case Serializer.NODES:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          CustomWidgetNode,
          { entity: 'Node' },
          '新增node',
          i + ' - node列表',
        )
        break
      case Serializer.TEXTURE:
        uiSchema[script.uuid].properties[i] = {
          component: CustomWidgetTexture,
          title: i,
          field: {
            entity: 'Texture',
          },
        }
        break
      case Serializer.TEXTURES:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          CustomWidgetTexture,
          { entity: 'Texture' },
          '新增texture',
          i + ' - texture列表',
        )
        break
      case Serializer.PREFAB:
        uiSchema[script.uuid].properties[i] = {
          component: CustomWidgetPrefab,
          title: i,
          field: {
            entity: 'Prefab',
          },
        }
        break
      case Serializer.PREFABS:
        dealTypeArray(
          i,
          formValue,
          uiSchema,
          script,
          CustomWidgetPrefab,
          { entity: 'Prefab' },
          '新增prefab',
          i + ' - prefab列表',
        )
        break
      case Serializer.ACTION:
        break
      case Serializer.ACTIONMANAGER:
        break
      case Serializer.ANIMATOR:
        break
      case Serializer.ANIMATORS:
        break
      case Serializer.AUDIO:
        break
      case Serializer.AUDIOS:
        break
      case Serializer.TEXTASSET:
        break
      case Serializer.TEXTASSETS:
        break
      case Serializer.EXCELASSET:
        break
      case Serializer.EXCELASSETS:
        break
      case Serializer.CUSTOMEVENT:
        uiSchema[script.uuid].properties[i] = {
          component: CustomWidgetCustomEvent,
          title: i,
        }
        break
      default:
        break
    }
    if (typeof script.createGui === 'function') {
      const config = script.createGui()
      let obj
      if (config && config[i]) {
        if (uiSchema[script.uuid].properties[i]) {
          Object.assign(uiSchema[script.uuid].properties[i], config[i])
        } else {
          uiSchema[script.uuid].properties[i] = _.cloneDeep(config[i])
        }
        // auto类型默认不显示,只有createGui里有改字段的配置才显示
        if (serializableFields[i] === Serializer.AUTO) {
          formValue[script.uuid][i] = script[i] || null
          uiSchema[script.uuid].initData[i] = script[i] || null
        }
        switch (config[i].component) {
          case 'int':
            uiSchema[script.uuid].properties[i].component = CustomWidgetInt
            uiSchema[script.uuid].properties[i].field = {
              min: config[i].field.min,
              max: config[i].field.max,
              step: config[i].field.step,
            }
            break
          case 'ints':
            obj = {
              entity: 'Int',
              min: config[i].field.min,
              max: config[i].field.max,
              step: config[i].field.step,
            }
            dealTypeArray(
              i,
              formValue,
              uiSchema,
              script,
              CustomWidgetInt,
              obj,
              '新增int',
              config[i].title + ' - int列表',
              config[i].title,
            )
            break
          case 'node':
            uiSchema[script.uuid].properties[i].component = CustomWidgetNode
            uiSchema[script.uuid].properties[i].field = {
              entity: 'Node',
            }
            if (script[i]) {
              formValue[script.uuid][i] = script[i].name
              uiSchema[script.uuid].initData[i] = script[i].name
            } else {
              formValue[script.uuid][i] = null
              uiSchema[script.uuid].initData[i] = null
            }
            break
          case 'nodes':
            dealTypeArray(
              i,
              formValue,
              uiSchema,
              script,
              CustomWidgetNode,
              { entity: 'Node' },
              '新增node',
              config[i].title + ' - node列表',
              config[i].title,
            )
            break
          case 'texture':
            uiSchema[script.uuid].properties[i].component = CustomWidgetTexture
            uiSchema[script.uuid].properties[i].field = {
              entity: 'Texture',
            }
            break
          case 'textures':
            dealTypeArray(
              i,
              formValue,
              uiSchema,
              script,
              CustomWidgetTexture,
              { entity: 'Texture' },
              '新增texture',
              config[i].title + ' - texture列表',
              config[i].title,
            )
            break
          case 'prefab':
            uiSchema[script.uuid].properties[i].component = CustomWidgetPrefab
            uiSchema[script.uuid].properties[i].field = {
              entity: 'Prefab',
            }
            break
          case 'prefabs':
            dealTypeArray(
              i,
              formValue,
              uiSchema,
              script,
              CustomWidgetPrefab,
              { entity: 'Prefab' },
              '新增prefab',
              config[i].title + ' - prefab列表',
              config[i].title,
            )
            break
          case 'point':
            uiSchema[script.uuid].properties[i].component = CustomWidgetPoint
            uiSchema[script.uuid].properties[i].field = {
              entity: 'Point',
            }
            break
          case 'points':
            dealTypeArray(
              i,
              formValue,
              uiSchema,
              script,
              CustomWidgetPoint,
              { entity: 'Point' },
              '新增坐标点',
              config[i].title + ' - 坐标点列表',
              config[i].title,
            )
            break
          case 'customEvent':
            uiSchema[script.uuid].properties[i].component =
              CustomWidgetCustomEvent
            break
          default:
            break
        }
      }
    }
  }
}

const initFormParam = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    initFormParam({ state, rootState }) {
      return new Promise((resolve, reject) => {
        const uiSchema = {}
        const formValue = {}
        const Serializer = rootState.workspace.game.data.Serializer

        // 为配合 el-schema-form 定义的数据结构 formValue、uiSchema
        const node = rootState.workspace.game.activeNode
          ? rootState.workspace.game.activeNode
          : rootState.workspace.game.sceneManager.currentSceneNode
        if (node) {
          node.scripts.forEach((item) => {
            formValue[item.uuid] = {}
            uiSchema[item.uuid] = {
              initData: {},
              uuid: item.uuid,
              type: 'object',
              properties: {},
            }
            formValue[item.uuid].scriptName = item.class
            formValue[item.uuid].script = item
            calForm(item, Serializer, formValue, uiSchema)
          })
        }

        resolve({ uiSchema, formValue })
      })
    },
  },
}

export default initFormParam
